<template>
  <subjects @onUpdate="onUpdate" @onReprove="onReprove" :config="config" :showPartnerCreateBtn="this.$root.userAllowedTo('create_user_credentials')" />
</template>

<script>
import AdminSubjects from "./AdminSubjects"

export default {
  name: 'AdminPartnersSubjects',
  components: { 'subjects': AdminSubjects },
  data: (vm) => {
    return {
      config: {
        title: 'Parceiros registrados',
        empty: 'Não existem parceiros configurados.',
        navItems: [{ url: '/admin/subjects/to_approve', title: 'Parceiros', icon: 'dashboard' }],
        load_url: vm.$root.urls.admin__company_partners,
        showConfigForm: true
      }
    }
  },
  methods: {
    onUpdate(companies, record) {
      if ((record.clearance_level * 1) == 0) {
        companies.splice(companies.findIndex(el => el.id === record.id), 1)
      }
    },
    onReprove(companies, record) {
      companies.splice(companies.findIndex(el => el.id === record.id), 1)
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/AdminPartnersSubjects.vue